import React, {createContext} from 'react';

const GlobalContext = createContext<any>({});


export default GlobalContext;